import { CheckCircle, CircleAlert, Clock4 } from 'lucide-react';
import StatusBadge, { STATUS as BASE_STATUS } from '../status-badge';

export const STATUS = {
  NOT_COMPLETED: 'not_completed',
  SUCCESS: 'success',
  IN_PROCESS: 'in_process',
} as const;

type IconStatusType = (typeof STATUS)[keyof typeof STATUS];
type StatusBadgeType = (typeof BASE_STATUS)[keyof typeof BASE_STATUS];
type StatusBadgeWithIconType = IconStatusType | StatusBadgeType;

type Props = {
  status: StatusBadgeWithIconType;
  className?: string;
};

const NEW_STATUSES: Record<IconStatusType, { background: string; text: string; label: string }> = {
  [STATUS.NOT_COMPLETED]: {
    background: 'bg-red-300/10',
    text: 'text-red-300',
    label: 'Не выполнен',
  },
  [STATUS.SUCCESS]: {
    background: 'bg-green-200/10',
    text: 'text-green-200',
    label: 'Успех',
  },
  [STATUS.IN_PROCESS]: {
    background: 'bg-blue-350/10',
    text: 'text-blue-350',
    label: 'В процессе',
  },
};

const isIconStatus = (status: StatusBadgeWithIconType): status is IconStatusType => {
  return Object.values(STATUS).some(statusValue => statusValue === status);
};

const StatusIcon = ({ status }: { status: IconStatusType }) => {
  switch (status) {
    case STATUS.SUCCESS:
      return <CheckCircle size={12} className="text-green-200" />;

    case STATUS.NOT_COMPLETED:
      return <CircleAlert size={12} className="text-red-300" />;

    case STATUS.IN_PROCESS:
      return <Clock4 size={12} className="text-blue-350" />;

    default:
      return null;
  }
};

const StatusBadgeWithIcon = ({ status, className }: Props) => {
  if (!isIconStatus(status)) {
    return <StatusBadge status={status} className={className} />;
  }

  const badge = NEW_STATUSES[status];

  return (
    <div
      className={`rounded-full py-1 px-3 inline-flex items-center gap-2 ${badge.background} ${className}`}
    >
      <span className={`flex-shrink-0 ${badge.text}`}>
        <StatusIcon status={status} />
      </span>

      <span className={`text-xs font-normal whitespace-nowrap ${badge.text}`}>{badge.label}</span>
    </div>
  );
};

export default StatusBadgeWithIcon;
